/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Authorized_Apps_GrantedInputs */



/**
* | output |
* | --- |
* | "Authorized {date}" |
*
* @param {Authorized_Apps_GrantedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_granted = /** @type {((inputs: Authorized_Apps_GrantedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_GrantedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Autorisée le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Autorizada el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Autorizado em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Autorizzata il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Authorized ${i?.date}`)
});